import cookie from "react-cookies";

const MEDIA_COOKIE = "media-id-qt";
const MEDIA_COOKIE_OPTS = {
  path: "/",
  domain: "qiktruck.co.za",
  maxAge: 86400,
  secure: true,
};

/** CloudFront media.admin only checks that this cookie name is present. */
export function saveMediaAccessCookie(token, maxAge = MEDIA_COOKIE_OPTS.maxAge) {
  if (!token) return;
  cookie.save(MEDIA_COOKIE, token, { ...MEDIA_COOKIE_OPTS, maxAge });
}

export function clearMediaAccessCookie() {
  cookie.remove(MEDIA_COOKIE, { path: "/", domain: "qiktruck.co.za" });
  cookie.remove(MEDIA_COOKIE, { path: "/" });
}
